"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var info = [{
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'archway',
    client_id: '07-tendermint-91',
    connection_id: 'connection-89'
  },
  chain_2: {
    chain_name: 'dymension',
    client_id: '07-tendermint-39',
    connection_id: 'connection-30'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-123',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-45',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'axelar',
    client_id: '07-tendermint-197',
    connection_id: 'connection-180'
  },
  chain_2: {
    chain_name: 'dymension',
    client_id: '07-tendermint-7',
    connection_id: 'connection-6'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-138',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-5',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'celestia',
    client_id: '07-tendermint-82',
    connection_id: 'connection-52'
  },
  chain_2: {
    chain_name: 'dymension',
    client_id: '07-tendermint-6',
    connection_id: 'connection-5'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-27',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-4',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'cosmoshub',
    client_id: '07-tendermint-1205',
    connection_id: 'connection-933'
  },
  chain_2: {
    chain_name: 'dymension',
    client_id: '07-tendermint-1',
    connection_id: 'connection-1'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-794',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'dymension',
    client_id: '07-tendermint-31',
    connection_id: 'connection-22'
  },
  chain_2: {
    chain_name: 'evmos',
    client_id: '07-tendermint-138',
    connection_id: 'connection-85'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-37',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-109',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'dymension',
    client_id: '07-tendermint-3',
    connection_id: 'connection-3'
  },
  chain_2: {
    chain_name: 'kava',
    client_id: '07-tendermint-162',
    connection_id: 'connection-203'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-3',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-144',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'dymension',
    client_id: '07-tendermint-17',
    connection_id: 'connection-10'
  },
  chain_2: {
    chain_name: 'kujira',
    client_id: '07-tendermint-169',
    connection_id: 'connection-132'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-10',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-160',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'dymension',
    client_id: '07-tendermint-16',
    connection_id: 'connection-9'
  },
  chain_2: {
    chain_name: 'neutron',
    client_id: '07-tendermint-82',
    connection_id: 'connection-61'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-9',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-675',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'dymension',
    client_id: '07-tendermint-14',
    connection_id: 'connection-7'
  },
  chain_2: {
    chain_name: 'noble',
    client_id: '07-tendermint-79',
    connection_id: 'connection-80'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-6',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-62',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'dymension',
    client_id: '07-tendermint-2',
    connection_id: 'connection-2'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-3086',
    connection_id: 'connection-2566'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-2',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-19774',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'dymension',
    client_id: '07-tendermint-29',
    connection_id: 'connection-20'
  },
  chain_2: {
    chain_name: 'secretnetwork',
    client_id: '07-tendermint-194',
    connection_id: 'connection-189'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-35',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-130',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'dymension',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  chain_2: {
    chain_name: 'stride',
    client_id: '07-tendermint-140',
    connection_id: 'connection-131'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-197',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}];
var _default = exports["default"] = info;